/**
 * @name stringHashCode
 * @description Given a string, returns a hash value of that string.
 * @param str - The string
 * @returns {number|*}
 */
export const stringHashCode = (str = '') => {
  let hash = 0
  let chr

  if (typeof str != 'string') return void 0
  let strLen = str?.length ?? 0
  if (strLen === 0) return void 0
  for (let i = 0; i < strLen; i++) {
    chr = str.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}
